// extracted by mini-css-extract-plugin
export default {"Emoji":"bbp_a bhr_i bhr_q bhr_j"};